import * as React from 'react';

import { OfferGallery } from './components/OfferGallery';
import { OfferGalleryBubble } from './components/OfferGalleryBubble';
import { useMessageContext } from '../../utils/messageContext';
import { OfferMessageContainer } from '../OfferMessageContainer';

export const ChatMessageOfferGalleryContainer: React.FC = () => {
  const { message, messageRef } = useMessageContext();

  const { offers, isRead, animation } = message;

  const [scrollStyles, setScrollStyles] = React.useState({
    hideLeft: true,
    hideRight: false,
  });

  const galleryRef = React.useRef<HTMLDivElement | null>(null);
  // oxlint-disable-next-line typescript/no-non-null-assertion
  React.useImperativeHandle(messageRef, () => galleryRef.current!);

  React.useEffect(() => {
    const gallery = galleryRef.current;

    if (!gallery) {
      return;
    }

    const updateArrows = () => {
      setScrollStyles({
        hideLeft: gallery.scrollLeft === 0,
        hideRight: Math.ceil(gallery.scrollLeft + gallery.clientWidth) >= gallery.scrollWidth,
      });
    };

    updateArrows();

    gallery.addEventListener('scroll', updateArrows);

    return () => {
      gallery.removeEventListener('scroll', updateArrows);
    };
  }, []);

  const scrollGallery = (direction: 'left' | 'right') => {
    if (galleryRef.current) {
      const scrollAmount = 300;

      galleryRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <OfferGallery
      offerBubbles={offers?.map((offer, index) => (
        <OfferGalleryBubble key={index} isRead={isRead}>
          <OfferMessageContainer offer={offer} />
        </OfferGalleryBubble>
      ))}
      animation={animation}
      scrollStyles={scrollStyles}
      onScrollLeft={() => scrollGallery('left')}
      onScrollRight={() => scrollGallery('right')}
      ref={galleryRef}
    />
  );
};
